import { render, staticRenderFns } from "./BlockUser.vue?vue&type=template&id=da2e8564&"
import script from "./BlockUser.vue?vue&type=script&lang=js&"
export * from "./BlockUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports